import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

export const SearchHistoryContainer = styled('div')(() => ({
  overflow: 'hidden',
  width: '100%',
}));

export const SearchHistoryTagWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  width: '100%',
  position: 'relative',
}));

export const SearchHistoryTag = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  overflowX: 'auto',
  overflowY: 'hidden',
  flex: 1,
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const NoSearchHistory = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  overflowX: 'auto',
  marginBottom: theme.spacing(3),
}));

export const NoSearchHistoryText = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.grey[300],
  lineHeight: theme.spacing(2.6),
}));
